import { SVGProps, Ref, forwardRef } from 'react';

export const PlayOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3 8.136 9.92 5.914C8.335 5.11 7.357 4.62 6.643 4.4c-.685-.211-.648.367-.72.963-.12.98-.123 2.357-.123 4.415v4.444c0 2.059.003 3.434.122 4.415.07.566.055 1.168.721.963.714-.22 1.692-.71 3.278-1.514l4.379-2.222c2.353-1.194 3.919-1.995 4.924-2.721.976-.705.976-1.022.976-1.142V12c0-.12 0-.437-.976-1.142-1.005-.726-2.571-1.527-4.924-2.72m.814-1.605-4.378-2.222C7.69 2.763 6.166 1.99 5.083 2.87 4 3.75 4 5.76 4 9.78v4.443c0 4.02 0 6.029 1.083 6.908s2.607.107 5.653-1.44l4.378-2.22C19.704 15.14 22 13.974 22 12s-2.295-3.14-6.886-5.47"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlayOutlinedSize24Glyph.displayName = 'PlayOutlinedSize24Glyph';
